var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fuid-form__select"},[_c('b-form-select',{attrs:{"id":_vm.id,"options":_vm.options},on:{"change":_vm.groupChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),(_vm.error)?_c('div',{staticClass:"fuid-form__select_error merror"},[_vm._v(_vm._s(_vm.$t('forms.groupfull')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }